import {
  CartStepper,
  ErrorFinishedOrder,
  FinishedOrder,
  FlexCol,
  FullOrder,
  InfoText,
} from '@bart.sk-eshop/eshop-defaults';
import { InfoType } from '@bart.sk-eshop/eshop-defaults/lib/components/Zemplin/General/InfoText';
import * as React from 'react';
import { __, __r } from '@bart.sk-eshop/react-i18n';
import LazyLoad from 'react-lazyload';
import { connect } from 'react-redux';
import { connectSsr } from '@bart.sk-eshop/ssr-service';
import InfoBanner from '../../components/_helpers/Default/InfoBanner';
import API, { ThenArg } from '../../services/API';
import styled from '../../theme/styled-components';
import { getPaymentUrl, isError, shouldRedirect } from '../../utilities/order';
import {
  BreadCrumbType,
  setBreadCrumbPath,
} from '../BreadCrumb/breadCrumbSlice';
import {
  cartIndexRoute,
  cartSecondStepRoute,
  cartThirdStepRoute,
  cartHalfStepRoute,
} from './utilities';
import {
  fetchFinishedOrder,
  finishedOrderDataSelector,
  finishedOrderIsFetchingSelector,
} from '../MyAccount/myAccountSlice';
import { LoaderWrapper } from '../../components/_helpers/Loader/Loader';
import { isSSR } from '@bart.sk-eshop/react-eshop-redirects/lib/action';
import { round } from '@bart.sk-eshop/eshop-defaults/lib/utilities';
import { prop } from '../../utilities';
import { withRouter, WithRouterProps } from 'react-router';
import {
  fbPurchase,
  ga4Purchase,
  ga4PurchaseWithEnchancedData,
  heurekaPurchase,
} from '@bart.sk-eshop/react-online-marketing';
import { getGoogleAdsId } from '../../configureTagManager';
import { GAObjectEnhancedConversionUserData } from '@bart.sk-eshop/react-online-marketing/lib/ga4-events';
import MetaTags from '../../components/_helpers/MetaTags/MetaTags';

const CART_STAGES = [
  { title: () => __('Nákupný košík'), stepNumber: 1, stepUrl: cartIndexRoute },
  {
    title: () => __('Prihlásenie'),
    stepNumber: 1.5,
    stepUrl: cartHalfStepRoute,
  },
  {
    title: () => __('Pokladňa'),
    stepNumber: 2,
    stepUrl: cartSecondStepRoute,
  },
  {
    title: () => __('Dokončená objednávka'),
    stepNumber: 3,
    stepUrl: cartThirdStepRoute,
  },
];

interface Props {
  dispatch: any;
  orderData: ThenArg<typeof API.getOrder>;
  isFetching: boolean;
}
interface State {
  hasRedirected: boolean;
}

class FinishedOrderContainer extends React.Component<
  Props & WithRouterProps,
  State
> {
  constructor(props) {
    super(props);
    this.state = {
      hasRedirected: false,
    };
  }

  public static async getInitialProps(props) {
    const {
      dispatch,
      params: { orderPublicId },
    } = props;

    dispatch(
      setBreadCrumbPath(BreadCrumbType.CART, {
        url: `${__r(
          'routes:dokoncena-objednavka',
          '/dokoncena-objednavka',
        )}/${orderPublicId}`,
      }),
    );
    try {
      await dispatch(fetchFinishedOrder(orderPublicId));
      return;
    } catch (exp) {
      console.log(exp);
      return;
    }
  }

  public async componentDidMount() {
    await this.updateOrderAnalytics();
  }

  public async componentDidUpdate(prevProps): Promise<void> {
    if (
      prop(prevProps, 'orderData.order_id') !==
      prop(this.props, 'orderData.order_id')
    ) {
      await this.updateOrderAnalytics();
    }
  }

  public updateOrderAnalytics = async (): Promise<void> => {
    const { orderData: order }: { orderData: any } = this.props;

    if (order && !isSSR() && order.analytics_sended === 0 && window) {
      const total = order.order_tprice;
      const totalWithoutVat = order.order_tprice_without_vat;
      const vatSum = total - totalWithoutVat;
      const shipping = order.payment.delivery_price;

      const items: any[] = [];
      order.items.forEach(item => {
        const itemId = item.product_id;
        const itemName = item.product_name;

        const itemPrice = item.unitprice;
        const itemPriceWithoutVat = round(
          itemPrice / (1 + item.vat_rate / 100),
          2,
        );

        const itemQuantity = item.quantity;
        if (itemId && itemName && itemPriceWithoutVat && itemQuantity) {
          items.push({
            name: itemName,
            sku: item.ordernr,
            price: itemPriceWithoutVat,
            quantity: itemQuantity,
          });
        }
      });

      fbPurchase(order);
      //heurekaPurchase(order);
      if (window.gtag) {
        /// @ts-ignore
        let gData = order.items
          .map(p => {
            return {
              ...p,
              unitprice: prop(
                p,
                'good_details_json.unitprice.price',
                p.unitprice,
              ),
            };
          })
          .filter(
            d =>
              (!d.isFromSale || d.product_id) &&
              d.product_name !== 'Doprava a platba',
          );
        const tax = order.order_tprice - order.order_tprice_without_vat;
        const currency = prop(order, 'order_tpricecurrency', 'EUR');
        // ga4Purchase(
        //   gData,
        //   order.order_nr,
        //   shipping,
        //   round(total, 2),
        //   round(vatSum, 2),
        //   getGoogleAdsId(),
        //   currency,
        // );

        const userData: GAObjectEnhancedConversionUserData = {
          email: prop(order, 'enchanced_user_data.sha256_email_address', ''),
          phone_number: prop(
            order,
            'enchanced_user_data.sha256_phone_number',
            '',
          ),
          first_name: prop(
            order,
            'enchanced_user_data.address.sha256_first_name',
            '',
          ),
          last_name: prop(
            order,
            'enchanced_user_data.address.sha256_last_name',
            '',
          ),
        };

        console.log('GA4 Purchase Enhanced Data:', {
          gData,
          orderNr: order.order_nr,
          shipping,
          total: round(total, 2),
          tax: round(vatSum, 2),
          adsId: getGoogleAdsId(),
          currency,
          userData,
        });

        ga4PurchaseWithEnchancedData(
          gData,
          order.order_nr,
          shipping,
          round(total, 2),
          round(vatSum, 2),
          getGoogleAdsId(),
          currency,
          userData,
        );

        // window.dataLayer.push({
        //   event: 'purchase',
        //   ecommerce: {
        //     transaction_id: order.order_nr,
        //     value: round(total, 2),
        //     tax: round(vatSum, 2),
        //     shipping: shipping,
        //     currency: currency,
        //     items: gData.map(item => ({
        //       item_id: item.product_id,
        //       item_name: item.product_name,
        //       category: item.product?.category_name || '',
        //       quantity: item.quantity,
        //       price: round(item.unitprice, 2),
        //     })),
        //   },
        // });
      }

      if (window._hrq) {
        heurekaPurchase(order);
      }

      try {
        await API.updateOrderAnalytics(order.public_id);
      } catch (e) {
        console.error('Update order analytics failed!');
      }
    }
  };

  public render() {
    const { orderData, isFetching, location } = this.props;
    const { hasRedirected } = this.state;

    if (isFetching) {
      return <LoaderWrapper />;
    }
    if (!orderData) {
      return (
        <Wrapper className="container container--wide">
          <InfoText
            type={InfoType.ERROR}
            info={__('Takáto objednávka neexistuje')}
          />
        </Wrapper>
      );
    } else if (shouldRedirect(orderData)) {
      const redirectUrl = getPaymentUrl(
        orderData.payment.payment_type,
        orderData.public_id,
      );
      if (
        redirectUrl &&
        window &&
        window.location &&
        window.location.href &&
        !hasRedirected
      ) {
        window.location.href = redirectUrl;
        this.setState({ hasRedirected: true });
      }
      return null;
    } else if (isError()) {
      return (
        <>
          <CartStepper
            steps={CART_STAGES}
            currentStepNumber={3}
            pathname={location.pathname}
          />
          <Wrapper className="container container--wide">
            <MetaTags tags={{ title: __('Chyba') }} />
            <ErrorFinishedOrder
              order={orderData}
              isFetching={isFetching}
              redirectUrl={getPaymentUrl(
                orderData.payment.payment_type,
                orderData.public_id,
              )}
              error={prop(location, 'query.error')}
            />
          </Wrapper>
        </>
      );
    }

    return (
      <>
        <CartStepper
          steps={CART_STAGES}
          currentStepNumber={3}
          pathname={location.pathname}
        />
        <Wrapper className="container container--wide">
          <MetaTags tags={{ title: __('Ďakujeme za váš nákup!') }} />
          <FinishedOrder
            order={orderData}
            isFetching={isFetching}
            location={location}
          />{' '}
          <FullOrder order={orderData} />
        </Wrapper>
      </>
    );
  }
}

const Wrapper = styled(FlexCol)`
  margin: 0 auto;
  width: 100%;
`;

const mapStateToProps = state => {
  return {
    user: state.auth.user,
    orderData: finishedOrderDataSelector(state),
    isFetching: finishedOrderIsFetchingSelector(state),
  };
};

const WithRouterFinished = withRouter(FinishedOrderContainer);
export default connect(mapStateToProps)(
  connectSsr({ displayName: 'FinishedOrderContainer' })(WithRouterFinished),
);
